import { useCallback, useEffect, useMemo, useState } from "react";
import { Container } from "./styled";
import secureLocalStorage from "react-secure-storage";
import { faAreaChart, faFileExcel, faMapLocation, faPrint, faSquare } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "antd";

//STYLES

//APP
import { useAccess } from "../../../../../../context/useAccess";
import { gerarPdfDataUrl } from "./meta/gerarPDFComparativoInsumos";
import { gerarExcelComparativoInsumos } from "./meta/gerarExcelComparativoInsumos";
import { estruturaComparativoInsumos } from "./meta";
import { Item__Atividades, ItemPropriedades } from "../../../../../../services/atividades/GET";
import { subareasDoTalhao, talhoesDaPropriedade } from "../atvsTodas/meta/lista-filtros";

//COMPONENTS
import Footer from "../../../../../../Components/Footer";
import ButtonCustom from "../../../../../../Components/ButtonCustom";
// import { Switcher } from "../../../../../../Components/CustomUi/Switcher";
import { PopSelect } from "../../../../../../Components/CustomUi/PopSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { obterLogo } from "../../../../precisao/mapaFertilidadeResumido/components/tabelaMapas/components/bookFertilidadeResumidoSeparado/components/capa/meta";


//PROPS
interface Props {
    data_propriedades: ItemPropriedades[];
    data_atividades: Item__Atividades[];
}

export const ComparativoInsumos: React.FC<Props> = ({ data_propriedades, data_atividades }) => {

    //CONS
    const { consultoria, nameCliente } = useAccess();

    //STATES
    const [cod_propriedade_selecionada, setCod_propriedade_selecionada] = useState<number>(null);
    const [nome_propriedade_selecionada, setNome_propriedade_selecionada] = useState<string>('');
    const [cod_talhao_selecionado, setCod_talhao_selecionado] = useState<number>(null);
    const [nome_talhao_selecionado, setNome_talhao_selecionado] = useState<string>('');
    const [cod_subarea_selecionada, setCod_subarea_selecionada] = useState<number>(null);
    const [nome_subarea_selecionada, setNome_subarea_selecionada] = useState<string>('');
    // const [incluir_insumos, setIncluir_insumos] = useState<boolean>(false);
    // const [incluir_patrimonios, setIncluir_patrimonios] = useState<boolean>(false);

    // PDF Modal states
    const [modalPdfOpen, setModalPdfOpen] = useState(false);
    const [pdfDataUrl, setPdfDataUrl] = useState<string | null>(null);
    const [gerandoPdf, setGerandoPdf] = useState(false);
    const [gerandoExcel, setGerandoExcel] = useState(false);

    useEffect(() => {
        setCod_talhao_selecionado(null);
        setNome_talhao_selecionado('');
        setCod_subarea_selecionada(null);
        setNome_subarea_selecionada('');
    }, [cod_propriedade_selecionada]);

    useEffect(() => {
        setCod_subarea_selecionada(null);
        setNome_subarea_selecionada('');
    }, [cod_talhao_selecionado]);

    const gerarPDF = useCallback(async () => {
        try {
            setGerandoPdf(true);
            const email_usuario_logado = secureLocalStorage.getItem('Itens')?.[0]?.email?.toLowerCase() || '';
            const estrutrua_comparativo = estruturaComparativoInsumos(data_atividades, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada);

            const headerInfo = {
                logo: obterLogo() ?? consultoria?.logo_url,
                titulo: "Relatório comparativo de Insumos",
                razaoSocial: consultoria.linha1 ?? '',
                cliente: nameCliente || '',
                autor: email_usuario_logado
            };

            const dataUrl = await gerarPdfDataUrl(estrutrua_comparativo, headerInfo);
            setPdfDataUrl(dataUrl);
            setModalPdfOpen(true);
        } catch (error) {
            console.error("Erro ao gerar PDF: ", error);
        } finally {
            setGerandoPdf(false);
        }
    }, [data_atividades, data_propriedades, consultoria, nameCliente, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada]);

    const gerarExcel = useCallback(async () => {
        try {
            setGerandoExcel(true);
            const email_usuario_logado = secureLocalStorage.getItem('Itens')?.[0]?.email?.toLowerCase() || '';
            const estrutrua_comparativo = estruturaComparativoInsumos(data_atividades, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada);

            const headerInfo = {
                logo: obterLogo() ?? consultoria?.logo_url,
                titulo: "Relatório comparativo de Insumos",
                razaoSocial: consultoria.linha1 ?? '',
                cliente: nameCliente || '',
                autor: email_usuario_logado
            };

            await gerarExcelComparativoInsumos(estrutrua_comparativo, headerInfo);
        } catch (error) {
            console.error("Erro ao gerar Excel: ", error);
        } finally {
            setGerandoExcel(false);
        }
    }, [data_atividades, data_propriedades, consultoria, nameCliente, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada]);

    const lista_talhoes = useMemo(
        () => talhoesDaPropriedade(cod_propriedade_selecionada, data_propriedades),
        [cod_propriedade_selecionada, data_propriedades]
    );

    const lista_subareas = useMemo(
        () => subareasDoTalhao(cod_propriedade_selecionada, cod_talhao_selecionado, data_propriedades),
        [cod_propriedade_selecionada, cod_talhao_selecionado, data_propriedades]
    );

    return (
        <Container style={{ minHeight: 'calc(100vh - 140px)' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 20 }}>
                <PopSelect
                    label="Propriedade"
                    empty_placeholder="Selecione a propriedade"
                    value={nome_propriedade_selecionada}
                    onChange={setNome_propriedade_selecionada}
                    onChangeId={setCod_propriedade_selecionada}
                    items={data_propriedades}
                    descricaoItem="nome"
                    idItem="cod"
                    icon={faMapLocation}
                />
                <PopSelect
                    label="Talhão"
                    empty_placeholder="Selecione o talhão"
                    value={nome_talhao_selecionado}
                    onChange={setNome_talhao_selecionado}
                    onChangeId={setCod_talhao_selecionado}
                    items={lista_talhoes}
                    descricaoItem="nome"
                    idItem="cod"
                    icon={faAreaChart}
                    disabled={!cod_propriedade_selecionada}
                    show_svg={lista_talhoes.length < 7}
                />
                <PopSelect
                    label="Subárea"
                    empty_placeholder={lista_talhoes.length === 0 ? "Nenhuma subárea disponível" : "Selecione a subárea"}
                    value={nome_subarea_selecionada}
                    onChange={setNome_subarea_selecionada}
                    onChangeId={setCod_subarea_selecionada}
                    items={lista_subareas ?? []}
                    descricaoItem="nome"
                    idItem="cod"
                    icon={faSquare}
                    disabled={!cod_talhao_selecionado || lista_subareas.length === 0}
                />

                {/* <Switcher
                    isChecked={incluir_insumos}
                    trigger={setIncluir_insumos}
                    label="Incluir Insumos"
                />
                <Switcher
                    isChecked={incluir_patrimonios}
                    trigger={setIncluir_patrimonios}
                    label="Incluir Patrimônios"
                /> */}
            </div>

            <Footer style={{ justifyContent: 'flex-start', gap: 10, width: '100%' }}>
                <ButtonCustom
                    icon={<FontAwesomeIcon icon={faFileExcel} />}
                    onClick={gerarExcel}
                    loading={gerandoExcel}
                >
                    Gerar Excel
                </ButtonCustom>
                <ButtonCustom
                    icon={<FontAwesomeIcon icon={faPrint} />}
                    onClick={gerarPDF}
                    type="secondary"
                    loading={gerandoPdf}
                >
                    Gerar PDF
                </ButtonCustom>
            </Footer>

            <Modal
                title="Visualizar PDF do relatório"
                open={modalPdfOpen}
                onCancel={() => { setPdfDataUrl(null); setModalPdfOpen(false) }}
                footer={null}
                width="80%"
                style={{ top: 20 }}
                destroyOnClose
            >
                {pdfDataUrl ? (
                    <iframe
                        src={pdfDataUrl}
                        width="100%"
                        height="700px"
                        style={{ border: 'none' }}
                        title="PDF Viewer"
                    />
                ) : (
                    <p>Carregando PDF...</p>
                )}
            </Modal>
        </Container>
    );
};